import { Container } from "reactstrap";
import ProfileMenu from "../components/Sidebar/ProfileMenu";
import './ProfileLayout.css';
import MainLayout from "./MainLayout";

function ProfileLayout({ children }) {
  return(
    <MainLayout>
      <main>
        <ProfileMenu />

        <Container className="py-4">
          {children}
        </Container>
      </main>
    </MainLayout>
  );
}

export default ProfileLayout;